import { useMemo, useState } from 'react';

import PageHeader from 'components/global/PageHeader';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import Calculator from './Calculator';
import CurrentPlanCard from './CurrentPlanCard';
import PlanComparison from './PlanComparison';
import * as S from './SavingsCalculator.styles';

const SavingsCalculator = () => {
	const [savingsCalculatorData, setSavingsCalculatorData] = useState();
	const [billingPeriod, setBillingPeriod] = useState('monthly');
	const isMobile = useMediaQuery(Breakpoints.mobile);

	const CurrentPlanCardComponent = useMemo(() => <CurrentPlanCard billingPeriod={billingPeriod} />, [billingPeriod]);

	return (
		<div>
			<PageHeader
				title="savingsCalculator"
				tooltip="savingsCalculator.tooltip"
				lordIcon="https://storage.googleapis.com/tryoto-public/lottie-files-compressed/calculator-icon-new.json.gz"
			/>
			<S.SavingsCalculatorPageContainer>
				<S.CalculationSide>
					<Calculator setCalculationData={setSavingsCalculatorData} setBillingPeriod={setBillingPeriod} />
					{!isMobile && CurrentPlanCardComponent}
				</S.CalculationSide>
				<PlanComparison savingsCalculatorData={savingsCalculatorData} billingPeriod={billingPeriod} />
				{isMobile && CurrentPlanCardComponent}
			</S.SavingsCalculatorPageContainer>
		</div>
	);
};

export default SavingsCalculator;
